import posthog from 'posthog-js'

import type { FeatureFlag } from '@/types/feature-flag'

export const isFeatureFlagEnabled = (featureName: FeatureFlag) => {
  // e2e tests are not currently being developed so disabled feature flags now
  if (import.meta.env.VITE_SCHOOL_ID === 'e2e') return false

  const featureFlagFromPosthog = posthog.isFeatureEnabled(featureName)

  return (
    (process.env.NODE_ENV === 'development' &&
      !import.meta.env.VITE_POSTHOG_KEY) ||
    featureFlagFromPosthog
  )
}
